/**
 * Tutoring Session Workflow Machine Config
 *
 * Domain: Tutoring > Session
 * Description: State machine for tutoring session lifecycle.
 * States: draft → scheduled → confirmed → completed/cancelled/rescheduled
 */
export const tutoringSessionConfig = {
    id: 'tutoring-session',
    initial: 'draft',
    states: {
        draft: {
            on: { SCHEDULE: { target: 'scheduled', guard: 'hasTutorAssigned' } },
        },
        scheduled: {
            on: {
                CONFIRM: { target: 'confirmed', guard: 'hasValidTimeSlot' },
                CANCEL: { target: 'cancelled', guard: 'isWithinCancellationWindow' },
            },
        },
        confirmed: {
            on: {
                COMPLETE: 'completed',
                CANCEL: { target: 'cancelled', guard: 'isWithinCancellationWindow' },
                RESCHEDULE: 'rescheduled',
            },
        },
        rescheduled: {
            on: { SCHEDULE: { target: 'scheduled', guard: 'hasTutorAssigned' } },
        },
        completed: {
            type: 'final',
        },
        cancelled: {
            type: 'final',
        },
    },
};
//# sourceMappingURL=tutoring-session.js.map